var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJumpTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2668_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 13.6449H1.5625C1.2875 13.6449 1.0625 13.8699 1.0625 14.1449C1.0625 14.4199 1.2875 14.6449 1.5625 14.6449H18.4375C18.7125 14.6449 18.9375 14.4199 18.9375 14.1449C18.9375 13.8699 18.7125 13.6449 18.4375 13.6449Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45581 13.082C2.45581 13.082 2.4877 13.082 2.50896 13.082C2.80127 13.0554 3.01386 12.795 2.98728 12.5027C2.95008 12.0988 2.95008 11.6895 2.99791 11.2909C3.0298 10.9986 2.82253 10.7329 2.53022 10.701C2.24323 10.6691 1.97218 10.8764 1.94029 11.1687C1.88183 11.647 1.87651 12.1306 1.92435 12.609C1.95092 12.8853 2.18477 13.0873 2.4505 13.0873L2.45581 13.082Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2799 7.00797C11.9282 7.34811 12.4969 7.81049 12.9752 8.36853C13.0815 8.49077 13.2303 8.55986 13.3845 8.55986C13.5067 8.55986 13.6289 8.51734 13.7246 8.4323C13.9478 8.24098 13.9797 7.90615 13.7884 7.68293C13.225 7.01328 12.5501 6.47119 11.7794 6.06195C11.519 5.92377 11.2001 6.02475 11.062 6.28517C10.9238 6.54559 11.0248 6.86447 11.2852 7.00265L11.2799 7.00797Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84042 6.56615C6.88825 6.56615 6.9414 6.56084 6.99455 6.54489C7.34 6.44391 7.7014 6.36951 8.06811 6.33762C8.44014 6.30042 8.80154 6.30042 9.15762 6.33762C9.44993 6.36419 9.71035 6.1516 9.73692 5.8593C9.7635 5.56699 9.55091 5.30657 9.2586 5.28C8.83343 5.23748 8.40294 5.23748 7.96713 5.28C7.53133 5.32251 7.10615 5.40755 6.69161 5.52979C6.40993 5.61482 6.25049 5.90713 6.33552 6.18881C6.40462 6.41734 6.6172 6.57146 6.84573 6.57146L6.84042 6.56615Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94475 9.42546C3.02447 9.4733 3.11482 9.49455 3.19985 9.49455C3.38586 9.49455 3.56656 9.39358 3.66754 9.22351C4.02363 8.58043 4.49663 8.02239 5.06531 7.56001C5.29384 7.374 5.33104 7.03917 5.14503 6.81064C4.95901 6.58211 4.62419 6.5449 4.39565 6.73092C3.71538 7.27833 3.15733 7.94267 2.73216 8.70267C2.58866 8.95777 2.68433 9.28197 2.93943 9.42546H2.94475Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8312 11.3324L14.6231 12.2837C14.7506 12.4379 15.0004 12.3953 15.0695 12.2093L15.5 11.0507C15.5691 10.8647 15.4096 10.6681 15.213 10.7053H15.1811C15.1333 10.2535 15.0376 9.80178 14.8994 9.37129C14.8091 9.08961 14.5115 8.93548 14.2298 9.02583C13.9481 9.11618 13.794 9.41381 13.8843 9.69548C14.0066 10.0781 14.0916 10.4767 14.1288 10.886C14.1288 10.886 14.1288 10.886 14.1288 10.8913L13.9853 10.9179C13.7887 10.9498 13.7036 11.1889 13.8312 11.343V11.3324Z",
    fill: "#98BDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2668_451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 9.42825,
    fill: "white",
    transform: "translate(0.5 5.24811)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpTo);
export default __webpack_public_path__ + "static/media/jump_to.fd3f5915cf59ef573fde9fd2e80a4410.svg";
export { ForwardRef as ReactComponent };